export default __webpack_public_path__ + "static/media/3CRV.7d7cb346.png";